import clientFactory from "../factories/http_client";
import {API} from "../api/api";

class FactorAttachmentService {

	/** @return  Promise<AxiosResponse<T>> */
	get = (projectId, futureMapId, factorId, attachmentId) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.projects.id.event_maps.id.factors.id.attachments.id.method,
			                             url: API.data.projects.id.event_maps.id.factors.id.attachments.id.url(projectId, futureMapId, factorId, attachmentId),
		                             });
	};

	/** @return  Promise<AxiosResponse<T>> */
	create = (projectId, futureMapId, factorId, attachment) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.projects.id.event_maps.id.factors.id.attachments.create.method,
			                             url: API.data.projects.id.event_maps.id.factors.id.attachments.create.url(projectId, futureMapId, factorId),
			                             data: API.data.projects.id.event_maps.id.factors.id.attachments.create.build(attachment),
			                             headers: {
				                             'Content-Type': 'application/json',
			                             }
		                             });
	};

	/** @return  Promise<AxiosResponse<T>> */
	save = (projectId, futureMapId, factorId, attachment) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.projects.id.event_maps.id.factors.id.attachments.save.method,
			                             url: API.data.projects.id.event_maps.id.factors.id.attachments.save.url(projectId, futureMapId, factorId),
			                             data: API.data.projects.id.event_maps.id.factors.id.attachments.save.build(attachment),
			                             headers: {
				                             'Content-Type': 'application/json',
			                             }
		                             });
	};

	/** @return  Promise<AxiosResponse<T>> */
	delete = (projectId, futureMapId, factorId, attachmentId) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.projects.id.event_maps.id.factors.id.attachments.delete.method,
			                             url: API.data.projects.id.event_maps.id.factors.id.attachments.delete.url(projectId, futureMapId, factorId),
			                             data: API.data.projects.id.event_maps.id.factors.id.attachments.delete.build(attachmentId),
			                             headers: {
				                             'Content-Type': 'application/json',
			                             }
		                             });
	};
}

export default FactorAttachmentService;